import React, {Component} from 'react'
import MainView from './MainView'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-97830907-1');

import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom'

class AppRouter extends Component {

  mainViewRenderer = ({match, location, history}) => {
    
    ReactGA.pageview(location.pathname)
    
    return (
      <MainView
        match={match}
        location={location}
        history={history}
      />
    )
  }

  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path="/piano/chord/root/:root_id/chord/:chord_id" render={this.mainViewRenderer}/>
            <Route exact path="/piano/chord/:pretty_name" render={this.mainViewRenderer}/>
            <Route exact path="/" render={this.mainViewRenderer}/>
          </Switch>
        </div>
      </Router>
    )
  }
}

export default AppRouter;


// WEBPACK FOOTER //
// ./src/AppRouter.js